
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { NumericInput } from "@/components/ui/numeric-input";
import { Banknote } from "lucide-react";
import { MetricTooltip } from "../../advanced/analytics/MetricTooltip";

interface EarnestMoneyInputProps {
  value: number;
  onChange: (value: number) => void;
}

export const EarnestMoneyInput: React.FC<EarnestMoneyInputProps> = ({ value, onChange }) => {
  return (
    <Card className="border-border/50">
      <CardContent className="pt-4 pb-4">
        <div className="flex items-start gap-3">
          <Banknote className="w-5 h-5 text-muted-foreground mt-1 shrink-0" />
          <div className="flex-1 space-y-2">
            <div className="flex items-center gap-1">
              <span className="text-sm font-medium">Earnest Money Deposit</span>
              <MetricTooltip metric="earnestMoney" />
            </div>
            <NumericInput
              value={value}
              onChange={onChange}
              prefix="$"
              min={0}
              max={100000}
              step={500}
              description="Applied as a credit toward your cash due at closing."
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
